import { CepPipe } from './../../pipe/cep.pipe';
import { Address } from './../../model/address';
import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'tx-address-input',
  templateUrl: './tx-address-input.component.html',
  styleUrls: ['./tx-address-input.component.css']
})
export class TxAddressInputComponent implements OnInit {

  constructor() {
    this.setPipes();
   }

  ngOnInit() {
  }

  private cepPipe: CepPipe;
  @Input() address: Address;


  setAddressState(value){
    this.address.state = value;
  }

  applyCepMask(event) {
    return this.cepPipe.transform(event.target.value, event.key);
  }

  setPipes(){
    this.cepPipe = new CepPipe();
  }

}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/shared/component/tx-address-input/tx-address-input.component.ts